import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/admins',
  component: Management,
  redirect: '/admins/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/admins/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.listAdmins
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/admins/ListTable'),
          meta: {
            auth: Auth.listAdmins,
            tabName: 'all'
          }
        },
        {
          path: 'enabled',
          component: () => import('@/views/admins/ListTable'),
          meta: {
            auth: Auth.listAdmins,
            tabName: 'enabled'
          }
        },
        {
          path: 'disabled',
          component: () => import('@/views/admins/ListTable'),
          meta: {
            auth: Auth.listAdmins,
            tabName: 'disabled'
          }
        }
      ]
    },
    // 新增
    {
      path: 'new',
      component: () => import('@/views/admins/New'),
      meta: {
        auth: Auth.createAdmin
      }
    },
    // 编辑
    {
      path: ':id/edit',
      component: () => import('@/views/admins/Edit'),
      meta: {
        auth: Auth.updateAdmin
      }
    },
    // 个人详情信息
    {
      path: 'my',
      component: () => import('@/views/admins/DetailLayout'),
      meta: {
        auth: Auth.common
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/admins/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.common
          }
        }
      ]
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/admins/DetailLayout'),
      meta: {
        auth: Auth.showAdmin
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/admins/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showAdmin
          }
        },
        // 权限
        {
          path: 'authorizations',
          component: () => import('@/views/admins/details/Authorizations'),
          meta: {
            tabName: 'authorizations', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showAdmin
          }
        },
        // 管理员操作日志
        {
          path: 'operated_model_version_log_audits',
          component: () => import('@/views/admins/details/ModelVersionLogAudits.vue'),
          meta: {
            tabName: 'operated_model_version_log_audits', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.listOperatedModelVersionLogAuditsOfAdmin
          }
        }
      ]
    }
  ]
}
